const MEDALS = ['🥇', '🥈', '🥉'];

// Same cold(low)->hot(high) scale as ClientsChart's bar gradient, kept
// identical so the two pages read as one visual language.
const LEADERBOARD_GRADIENT = 'linear-gradient(to right, #63dac8 0%, #4ade80 28%, #ffd23f 55%, #ff8a3d 78%, #ff5140 100%)';

// Generic ranked bar list reused for all three /students leaderboards (tests
// completed, accuracy %, lessons last month) - caller supplies pre-formatted
// display strings so this component stays unit-agnostic. Every bar samples
// the SAME fixed gradient from its left edge - since the track is fluid
// width (not a fixed px like ClientsChart's), each bar's background is sized
// to (100/ratio)% of its own (already-scaled) width, which always resolves
// to exactly the track's full width - so a short bar only shows the cool
// left portion of the scale, and only the max-value bar reaches red at its tip.
// Identity still comes from the medal/rank, not hue - the gradient encodes
// magnitude, not which student a bar belongs to.
export default function StudentsLeaderboard({ title, items }) {
   if (!items || items.length === 0) {
      return '';
   }
   const max = Math.max(...items.map(i => i.value));

   return (
      <div className='students-leaderboard-card'>
         <p className='students-leaderboard-title'>{title}</p>
         <div className='students-leaderboard'>
            {items.map((item, i) => {
               const ratio = max > 0 ? item.value / max : 0;
               return (
                  <div className='students-leaderboard-row' key={item.studentId}>
                     <span className={'students-leaderboard-rank' + (i < 3 ? ' students-leaderboard-medal' : '')}>
                        {i < 3 ? MEDALS[i] : (i + 1) + '.'}
                     </span>
                     <span className='students-leaderboard-name'>{item.name} {item.surname}</span>
                     <div className='students-leaderboard-track'>
                        <div className='students-leaderboard-bar' style={{
                           width: (ratio * 100) + '%',
                           backgroundImage: LEADERBOARD_GRADIENT,
                           backgroundSize: (ratio > 0 ? (100 / ratio) : 100) + '% 100%',
                           backgroundPosition: 'left',
                           backgroundRepeat: 'no-repeat',
                        }}></div>
                     </div>
                     <span className='students-leaderboard-value'>{item.displayValue}</span>
                  </div>
               );
            })}
         </div>
      </div>
   )
}
